var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"login error-page p403\"><div class=\"wrapper-main\"><flash-message></flash-message><div class=\"container\"><img" + (jade.attr("src", require("./403-error-illustration.svg"), true, true)) + " width=\"165\" alt=\"\"><h2>You don't have permission to view this page</h2><p>Our system thinks you're trying to access a page that you don't have permission to view. It probably just means that you're not logged in or you're logged into a different account.</p><p>Please try logging in again before you access this page.</p><a href=\"#\" ui-sref=\"root.home.landing\">Go to Login Page</a></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/home/403/403.jade
// module id = 574
// module chunks = 0